import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Metadata|Edit Value Dialog|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ClientMetadata,
	portal: 'SP',
};

export type SPSystemMetadataEditValueDialogLocNames =
	| 'SPSystemMetadataEditValueDialogTitle'
	| 'SPSystemMetadataEditValueDialogConfirm'
	| 'SPSystemMetadataEditValueDialogCancel'
	| 'SPSystemMetadataEditValueDialogLabelType'
	| 'SPSystemMetadataEditValueDialogLabelExternalId'
	| 'SPSystemMetadataEditValueDialogLabelAttributeName'
	| 'SPSystemMetadataEditValueDialogLabelValue'
	| 'SPSystemMetadataEditValueDialogErrorValueRequired';

export const spSystemMetadataEditValueDialogLocs: LocDefs<SPSystemMetadataEditValueDialogLocNames> =
	{
		SPSystemMetadataEditValueDialogTitle: {
			defaultValue: 'Edit Value',
			description: 'Title for the edit metadata value dialog.',
			displayPath: `${pathStart}Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogConfirm: {
			defaultValue: 'Save',
			description: 'Confirm button for the edit value dialog.',
			displayPath: `${pathStart}Confirm`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button for the edit value dialog.',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogLabelType: {
			defaultValue: 'Type',
			description: 'Read-only label for type in dialog.',
			displayPath: `${pathStart}Type`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogLabelExternalId: {
			defaultValue: 'External ID',
			description: 'Read-only label for external ID in dialog.',
			displayPath: `${pathStart}External Id`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogLabelAttributeName: {
			defaultValue: 'Attribute Name',
			description: 'Read-only label for attribute name in dialog.',
			displayPath: `${pathStart}Attribute Name`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogLabelValue: {
			defaultValue: 'Value',
			description: 'Editable value field label in dialog.',
			displayPath: `${pathStart}Value`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPSystemMetadataEditValueDialogErrorValueRequired: {
			defaultValue: 'Value is required.',
			description: 'Error when value field is empty.',
			displayPath: `${pathStart}Error Value Required`,
			displayType: 'Content',
			...sharedProperties,
		},
	};

export type SPSystemMetadataEditValueDialogLocType =
	LocMap<SPSystemMetadataEditValueDialogLocNames>;
